import { useTranslation } from 'react-i18next';

export default function useRelativeTime() {
    const { t } = useTranslation();

    function getRelativeTime(inputDate: Date) {
        const currentDate = new Date();
        const inputDateObj = new Date(inputDate);
        const timeDifference = currentDate.getTime() - inputDateObj.getTime();
        const absDifference = Math.abs(timeDifference);

        const isFuture = timeDifference < 0;
        const minutes = Math.floor(absDifference / 60000);
        const hours = Math.floor(minutes / 60);
        const days = Math.floor(hours / 24);
        const months = Math.floor(days / 30);
        const years = Math.floor(days / 365);

        let relativeTime = '';

        if (absDifference < 86400000) {
            if (minutes < 60) {
                relativeTime = isFuture
                    ? t('common:time.minutesAhead', 'in {count} minutes', { count: minutes })
                    : t('common:time.minutesAgo', '{count} minutes ago', { count: minutes });
            } else {
                relativeTime = isFuture ? t('common:time.todayAhead', 'later today') : t('common:time.today', 'today');
            }
        } else if (absDifference < 172800000) {
            relativeTime = isFuture ? t('common:time.tomorrow', 'tomorrow') : t('common:time.yesterday', 'yesterday');
        } else if (absDifference < 2592000000) {
            relativeTime = isFuture
                ? t('common:time.daysAhead', 'in {count} days', { count: days })
                : t('common:time.daysAgo', '{count} days ago', { count: days });
        } else if (absDifference < 31536000000) {
            relativeTime = isFuture
                ? t('common:time.monthsAhead', 'in {count} months', { count: months })
                : t('common:time.monthsAgo', '{count} months ago', { count: months });
        } else {
            relativeTime = isFuture
                ? t('common:time.yearsAhead', 'in {count} years', { count: years })
                : t('common:time.yearsAgo', '{count} years ago', { count: years });
        }

        return relativeTime;
    }
    return getRelativeTime;
}
